import { IFeature } from '@esri/arcgis-rest-types';

export default class ContextService {

  private static instance: ContextService;
  public gadm_0Features: IFeature[] = [];
  public gadm_1Features: any = {};
  public gadm_2Features: any = {};
  public refFeatures: any = {};
  public refPrivateSectorFeatures: any = {};
  public layersInfos: any = {};

  /**
   * Init service instance
   */
  public static initInstance(): void {
    if (!ContextService.instance) {
      ContextService.instance = new ContextService();
    }
  }

  /**
   * Get service instance
   */
   public static getInstance(): ContextService {
    return ContextService.instance;
  }
}
